<template>
  <div class="section section-trailer" id="trailer-section">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="text-center col-md-12 col-lg-9">
          <h3 data-aos="fade-up" class="title deco1">{{$t(`Official Trailer`)}}</h3>
          <div v-if="$i18n.locale == 'ch-zn'" class="video-container">
            <iframe width="100%" height="100%" id="ytplayer" allowfullscreen frameborder="0" src="https://player.youku.com/embed/XNDYyOTc1OTM4OA=="></iframe>
          </div>
          <div v-else class="video-container">
            <iframe width="100%" height="100%" id="ytplayer" allowfullscreen frameborder="0" src="https://www.youtube.com/embed/24xnAK6HTzg"></iframe>
          </div>
          <h5 data-aos="fade-right" class="description" style="padding-top: 30px;">
            {{$t(`official trailer desc`)}}
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
};
</script>
<style></style>
